// W-0821 — Barra de progresso "Lote N de M" durante envio em chunks.

import React from 'react';
import { ProgressBar, Card } from 'react-bootstrap';

const BarraProgressoChunks = ({ chunkAtual, totalChunks, label }) => {
  if (!totalChunks || totalChunks <= 0) return null;
  const pct =
    chunkAtual > 0 ? Math.round((chunkAtual / totalChunks) * 100) : 0;
  return (
    <Card className="mb-3 border-info">
      <Card.Body className="py-2">
        <div className="d-flex justify-content-between mb-1">
          <strong>{label || 'Transferindo boletos...'}</strong>
          <span className="text-muted">
            Lote {chunkAtual} de {totalChunks}
          </span>
        </div>
        <ProgressBar now={pct} label={`${pct}%`} animated striped />
      </Card.Body>
    </Card>
  );
};

export default BarraProgressoChunks;
